import type { UseWhatsNewHomeReturn } from "~/pages/home/hooks/useWhatsNewState";

import { createContext } from "react";

const WhatsNewContext = createContext<UseWhatsNewHomeReturn | null>(null);
export default WhatsNewContext;
